<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
          <sidebar-item
          :link="{
            name: 'Websites',
            icon: 'ni ni-world-2 text-green',
            path: '/websites'
          }">
        </sidebar-item>
      </template>

    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';


  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import {AuthService} from '@/common/auth.service';
  import { Role } from '@/helpers/role.js';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition,
    },
     data() {
    return {
      auth: AuthService,
      role: Role
    }
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.$router.push('/websites')
    },
    created() {

    }
  };
</script>
<style lang="scss">
</style>
